<template>
<div>
    <!-- save line length -->
    <div class="row">
        <div class="col-md-12">
            <div class="card bg-white border-dark">
                <div class="card-header">Save line length</div>
                <div class="card-body border-top">
                    <div class="alert alert-danger" v-show="save.validations.length > 0">
                        <span v-for="(validation, index) in save.validations" :key="index">{{ validation }} <br /></span>
                    </div>
                    <div class="form-row">
                        <!-- save -->
                        <div class="form-group col-md-6">
                            <label>File name</label>

                            <input type="text" class="form-control" name="name" v-model="save.name" />
                        </div>

                        <div class="form-group col-md-6">
                            <label>Radian</label>

                            <input type="number" class="form-control" name="name" v-model="save.radian" />
                        </div>

                    </div>

                    <!-- save fiber network -->
                    <div class="form-row">
                        <label>Draw lines</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <input type="checkbox" id="save_all_junction_distances" v-model="
                                                    save.draw_lines
                                                " />
                                </div>
                            </div>
                            <input type="number" class="form-control" name="draw_lines_value" v-model="save.draw_lines_value" />

                            <div class="form-group col-md-4 my-auto">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="persistence_data " v-model="save.persistence_data " />
                                    <label class="custom-control-label" for="persistence_data ">Persistence data</label>
                                </div>
                            </div>
                            <div class="form-group col-md-12">
                                <button class="btn btn-primary pull-right" @click="addSave">
                                    <i class="fa fa-save pr-2"></i><span>Add parameter</span>
                                </button>
                            </div>

                        </div>

                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>
                                            Image name
                                        </th>
                                        <th>
                                            Radian
                                        </th>
                                        <th>
                                            draw lines
                                        </th>
                                        <th>
                                            persistence data
                                        </th>
                                        <th class="th-fit"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(member, index) in form.saves" :key="index">
                                        
                                        <td>{{ member.name }}</td>
                                        <td>{{ member.radian }}</td>
                                        <td>{{ member.draw_lines?'yes ('+ member.draw_lines_value+')':'no' }}</td>
                                        <td>{{ member.persistence_data?'yes':'no' }}</td>
                                        <td>
                                            <i class="fa fa-times text-danger" @click="removesave(index)"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
</div>
</template>

<script>
export default {
    props: ["form"],
    data() {
        return {

            save: {
                //save: 'original network 0 0 255 2 name <imagename>_traced only_loops 255 0 0 1', #
                //hinter name: Bildpfad*/
                name: "", //Dateiname
                radian: 0.35,
                draw_lines: false,
                draw_lines_value: 10,
                persistence_data: false,
                validations: []
            }
        };
    },
    methods: {
        removesave(index) {
            this.form.saves.splice(index, 1);
        },
        addSave() {
            console.log("test");
            this.save.validations = [];

            if (!this.save.name) { 
                this.save.validations.push("Name must be set");
            }
            
            if (this.save.radian < 0 || this.save.radian > Math.PI) {
                this.save.validations.push("Radian must be between 0 and π");
            }

             if (this.save.validations.length < 1) {
                this.form.saves.push(this.copyObject(this.save));
                this.save.name = "";
                this.save.radian=  0.35;
                this.save.draw_lines=  false;
                this.save.draw_lines_value=  10;
                this.save.persistence_data=  false;
            }

        },
        removeSave(index) {
            this.form.saves.splice(index, 1);
        },
        copyObject(obj) {
            var cp = {};
            for (var o in obj) {
                cp[o] = obj[o];
            }
            return cp;
        },
        submit() {
            axios
                .post("/task", this.form)
                .then(response => {
                    console.log("successful");
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        this.form.errors = error.response.data.errors;
                    }
                });
        }
    }
};
</script>
